<template>
	<div>
		<slot name="loading-page" v-if="loading"></slot>

		<div class="vh-100" v-else :class="{'bg-grey': bgGrey, 'bg-white': bgWhite}">
			<slot name="title-bar"></slot>
			<slot name="search-bar"></slot>

			<div
				class="content-wrapper vh-100"
				:style="'position: relative; '+ (isWebview() ? 'padding-bottom: 0px;' : 'padding-bottom: 55px;')"
				:class="[containerName, !isSearch ? 'main-page' : '', isMobile ? 'fixed-button' : 'sticky-button']"
			>

				<slot name="content"></slot>
				<slot name="skeleton"></slot>
				<slot name="empty-state"></slot>
			</div>

			<slot name="filter"></slot>
		</div>
    <div class="bg-white w-100" :style="{position: 'absolute', top: '0px'}">
      <slot name="export-import"></slot>
    </div>
		<slot name="modal"></slot>
	</div>
</template>

<script>
export default {
	name: "SOSlotBase",
	props: {
		containerName: String,
		loading: Boolean,
		isSearch: Boolean,
		bgGrey: Boolean,
		bgWhite: Boolean,
	},
	computed: {
		isMobile: {
			get() {
				return window.innerWidth < 600
			}
		},
	},
}
</script>
<style scoped>
	.view-original .sticky-button >>> .btn_action_wrapper, .action-btn {
		position: sticky !important;
	}
	.view-original .fixed-button >>> .btn_action_wrapper, .action_btn {
		position: fixed !important;
		bottom: 64px;
		width: 100%;
	}

	.view-iframe .sticky-button >>> .btn_action_wrapper, .action-btn {
		position: sticky !important;
		bottom: 7px !important;
	}
	.view-iframe .fixed-button >>> .btn_action_wrapper, .action_btn {
		position: fixed !important;
		bottom: 0px;
		width: 100%;
	}
</style>